import { useState, Suspense, lazy, useEffect, useRef } from 'react';

const ChatShell = lazy(() => import('./ChatShell'));

export default function FloatingLauncher() {
  const [open, setOpen] = useState(false);
  const drawerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const prev = document.activeElement;
    setTimeout(() => drawerRef.current?.focus(), 50);
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('keydown', onKey); prev?.focus?.(); };
  }, [open]);

  if (localStorage.getItem('role') !== 'USER') return null;

  return (
    <>
      {/* Floating trigger button — only visible when panel is closed */}
      {!open && (
        <button
          aria-label="Open Symptom Checker"
          title="Open Symptom Checker"
          onClick={() => setOpen(true)}
          style={{
            position: 'fixed',
            right: 22,
            bottom: 22,
            width: 56,
            height: 56,
            borderRadius: '50%',
            border: 'none',
            background: 'linear-gradient(145.19deg, #004276 -8.63%, #00BD7F 93.45%)',
            color: '#fff',
            boxShadow: '0 8px 28px rgba(9,4,140,0.28)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2001,
            cursor: 'pointer',
          }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M12 2C7.03 2 3 5.58 3 10c0 2.9 1.64 5.48 4.22 7.04L7 22l4.4-2.28C12.25 19.9 13.11 20 14 20c4.97 0 9-3.58 9-8s-4.03-10-9-10z"/>
          </svg>
        </button>
      )}

      {/* Panel */}
      <div
        ref={drawerRef}
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-label="Symptom Checker"
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: 420,
          maxWidth: '100vw',
          zIndex: 2000,
          display: 'flex',
          flexDirection: 'column',
          background: '#F0FAF7',
          boxShadow: '-12px 0 48px rgba(0,0,0,0.16)',
          transform: open ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
          pointerEvents: open ? 'all' : 'none',
        }}
      >
        <Suspense fallback={
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#004276', fontSize: 14 }}>
            Loading…
          </div>
        }>
          <ChatShell onClose={() => setOpen(false)} />
        </Suspense>
      </div>
    </>
  );
}
